window.excludePages=["academia"];
const getCurrentPage = window.location.pathname.split("/").pop();
window.addEventListener('scroll', function() {
  const sections = document.querySelectorAll('#MainContent .section');
  //const scrollPosition = window.scrollY + window.innerHeight / 2; // Middle of the viewport
  const scrollPosition = window.scrollY + window.innerHeight * 0.6;

  sections.forEach(section => {
    if (window.scrollY > 610) {
      if(window.excludePages.find((element) => element == getCurrentPage)){
        //no agregamos la class
      }else{
        section.classList.add("dark-theme");
      }
    }else{
      section.classList.remove("dark-theme");
    }
  });
});